module.controller('viewAllCardsCtrl', ['baseURI','CARDS','$http','$scope', '$q','Transform','accountService','Session', '$window', 'cacheService', 'localStorageService', '$state',
  function ( baseURI, CARDS, $http, $scope, $q, Transform, accountService, Session, $window, cacheService, localStorageService, $state) {

    $scope.username = Session.getUsername();
    $scope.accounts = accountService.getAccounts();
    $scope.getAccountLength = getAccountLength;
    $scope.alertMessage = 'Sorry, we were unable to update your card at this time. \n If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
    $scope.loading = false;
    $scope.viewType = 'list';
    $scope.searchAccount = Session.getSearch();
    $scope.loadMoreCards = loadMoreCards;

    var endOfList = false;
    var count = 10;
    var atmUrl = baseURI + 'card/cash/access';
    var statusUrl = baseURI + 'card/status';

    // only show grid view if primary is incentive or gift card
    if (Session.getIsIncentive() || Session.getIsGift()) {
        $scope.hideViewOptions = true;
        $scope.viewType = 'grid';
    }

    //do not allow the user to view this page if they are not verified
    if(Session.getEnrollmentErrorCode() === 150){
      var user = {
        username: $scope.username
      };
      $state.go('member.home.profile/verification.step1',user);
    }

    $scope.changeView = function(viewType) {
      if (viewType === 'grid' && $scope.accounts.length < 20) {
        loadMoreCards(20);
      }

      $scope.viewType = viewType;
    };

    $scope.cardSelected = function(username){
      accountService.setAccounts($scope.accounts);
      $state.go('member.home', { username: username });
    };

    $scope.goBack = function(){
      cacheService.clear('subcard');
      Session.setSearch('');
      $state.go('member.home', { username: Session.getUsername() });
    };

    $scope.reset = function(){
      $scope.searchAccount = '';
      $scope.cardSearch();
    };

    //card search
    $scope.cardSearch = function(){
      var delayTimer;
      var cardSearchUrl = baseURI + 'cards/0/10';

      if ($scope.searchAccount) {
        cardSearchUrl += '/' + $scope.searchAccount;
      }

      Session.setSearch($scope.searchAccount);

      //reset the timer
      clearTimeout(delayTimer);

      delayTimer = setTimeout(function(){
        $http({
          method: 'GET',
          url: cardSearchUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
          }
        }).then(function (resp){
          var data = resp.data;

          var cleanData = [];
          for(var a in data.Data){
            cleanData.push(accountService.transformAccount(data.Data[a]));
          }
          $scope.accounts = cleanData;
        }).catch(function(error){
          $scope.accounts.showModal = true;
        });
      }, 200);
    };

    //function for setting the card to Active state
    $scope.updateStatus = function(account){
      $scope.loading = true;
      var req = {
        Username: account.username,
        Status: account.status === 'Active' ? 13 : 10,
      };
      account.statusCode = req.Status.toString();

      $http({
        method: 'PUT',
        url: statusUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode(req)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        if(data.Success){
          accountService.updateAccounts([account]);
        } else {
          toggleStatusBack(account);
          $scope.accounts.showModal = true;
        }
      }).catch(function (error){
        $scope.loading =false;
        toggleStatusBack(account);
        $scope.accounts.showModal = true;
      });
    };

    //function to get the length the account list for account status
    function getAccountLength(){
      return $scope.accounts.length;
    }

    //function for reverting account status if api call failed
    function toggleStatusBack(account){
      if(account.status === 'Active'){
        account.statusCode = '13';
        account.status =  'Inactive';
      }
      else if(account.status === 'Inactive'){
        account.statusCode = '10';
        account.status = 'Active';
      }
    }

    $scope.updateATMAccess = function(account){
      var req = {
        Username: account.username,
        ATMAccess: !account.atmAccess
      };

      $http({
        method: 'PUT',
        url: atmUrl,
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode(req)
      }).then(function(resp){
        var data = resp.data;

        cacheService.clear('atm', account.username);
        accountService.updateAccounts([account]);
      }).catch(function(error){
        account.atmAccess = !account.atmAccess;
        $scope.accounts.showModal = true;
      });
    };

    //function for paginated scroll
    function fetchCardPage(lastId, count){
      var deferred = $q.defer();
      var startIndex = lastId ? lastId : 0;
      $scope.loading = true;
      $scope.disabled = true;
      var cardPaginatedUrl = baseURI + 'cards/' + startIndex + '/' + count;
      if ($scope.searchAccount) {
        cardPaginatedUrl += '/' + $scope.searchAccount;
      }

      $http.get(cardPaginatedUrl, {cache: false})
        .then(function (resp){
          var data = resp.data;

          if(data.Data && data.Data.length > 0) {
            deferred.resolve(data);
          } else {
            $scope.disabled = false;
            $scope.loading = false;
            endOfList = true;
            deferred.reject(data);
          }
        }).catch(function(error){
          $scope.disabled = false;
          $scope.loading = false;
          deferred.reject(error);
        });

      return deferred.promise;
    }

    function getCards(response){
      //transform the data and append to the account list
      for(var a in response){
        //do not allow duplicates in the account list
        var duplicate;
        for (var sa in $scope.accounts) {
          if (response[a] === $scope.accounts[sa]) {
            duplicate = true;
            break;
          }
        }
        if (!duplicate){
          $scope.accounts.push(accountService.transformAccount(response[a]));
        }
      }
      //stop the loading
      $scope.disabled = false;
      $scope.loading = false;
    }

    //load more card rows
    function loadMoreCards(count){
      // prevent waterfall infinite loading
      if (endOfList) {
        return;
      }

      var cards = $scope.accounts;
      // check if there is card data
      if ($scope.loading || cards.length < 1) {
        return;
      }

      //get the id of the last card
      var lastId = cards[cards.length - 1].id;

      var promise = fetchCardPage(lastId, count || 10);
      promise.then(function(response) {
        getCards(response.Data);
      },
        function(reason) {
          $scope.disabled = false;
          $scope.loading = false;
        });
    }

  }]);
